import { TPartialVersionedResource } from "app/queryProvider/interfaces";

export const coreVersionedResource: TPartialVersionedResource<"televisits" | "questionnaire-results"> = {
  televisits: {
    name: "televisits",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
  "questionnaire-results": {
    name: "questionnaire-results",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
};
